import { useState, useEffect, useRef } from 'react';
import { Box, Button, Checkbox, FormControlLabel, IconButton, TextField, Typography } from '@mui/material'
import { Doctor_Notes_Layout_Json } from '../../../Utility/Constants';
import { ImagePaths } from '../../../Utility/ImagePaths';
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../Styles/Colors';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import "./DocSettings.css";


// const defaultAddNew = { field_name: '', label: '', custom_name: '', is_active: false, is_new: true };
const deepCopyObj = (data) => {
    return JSON.parse(JSON.stringify(data));
}
const convertLowerCase = (data) => {
    return data?.toLowerCase()
}
const DoctorLayoutConfig = () => {
    const [state, setState] = useState({
        layoutData: [],
        newLayoutData: [],
        drag_label: null,
        max_new_layout_alloted: 0,
        new_layout_count: 0,
        org_new_layout_count: 0,
        is_save_layout: false,
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: ''
    })

    const labelRefs = useRef({});
    const pendingAction = useRef({ newId: null, fromLastAdd: null });

    useEffect(() => {
        getLayoutConfiguration();
    }, [])

    // useEffect(() => {
    //     const { newId, fromLastAdd } = pendingAction.current;

    //     if (!fromLastAdd) {
    //         labelRefs.current[newId]?.focus();
    //     } else {
    //         postLayoutConfiguration();
    //     }

    //     pendingAction.current = { newId: null, fromLastAdd: null };

    // }, [state.left_Fields_data]);

    const updateState = (updates) => setState((prev) => ({
        ...prev,
        ...updates
    }));


    const errorMessage = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const successMessage = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }


    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // const canAddNewlayout = () => {
    //     return (state.max_new_layout_alloted - state.new_layout_count) > 1;
    // }

    const validateDuplicate = (arr) => {
        let msg = null;
        const nameSet = new Set();
        const labelSet = new Set();
        arr?.forEach((item) => {
            if (!item.label || !item.custom_name) {
                msg = `Please enter ${!item.label ? "system name" : "custom name"}`;
                setState((prev) => ({...prev, is_save_layout: false }));
                return;
            }
            if (labelSet.has(convertLowerCase(item.label)) || nameSet.has(convertLowerCase(item.custom_name))) {
                msg = `${labelSet.has(item.label) ? "System" : "Custom"} Name is duplicate`;
                setState((prev) => ({...prev, is_save_layout: false }));
                return;
            }
            labelSet.add(convertLowerCase(item.label));
            nameSet.add(convertLowerCase(item.custom_name));
        });
        return msg;
    }

    // const getNextId = (layout) => {
    //     const maxId = layout.reduce((max, item) => Math.max(max, item.id), 0);
    //     return maxId + 1;
    // };

    // const handleAddItem = (fromLastAdd = false) => {
    //     const newId = getNextId(state.layoutData);
    //     pendingAction.current = { newId, fromLastAdd };
    //     const updatedFields = [...state.layoutData];
    //     if (updatedFields.length > 0) {
    //         updatedFields[updatedFields.length - 1] = {
    //             ...updatedFields[updatedFields.length - 1],
    //             is_newly_add: true
    //         };
    //     }
    //     updateState({
    //         layoutData: fromLastAdd ? [...updatedFields]
    //             : [...updatedFields, deepCopyObj({ ...defaultAddNew, id: newId })],
    //         new_layout_count: state?.new_layout_count + 1,
    //         lastAddedId: newId,
    //     })
    // }

    const handleDrag = (e) => {
        updateState({
            drag_label: e.currentTarget.id
        })
    }

    const handleDrop = (e) => {
        e.preventDefault();

        const dragLabel = state.drag_label;
        const dropLabel = e.currentTarget.id;

        if (!dragLabel || dragLabel === dropLabel) return;

        const items = [...state.layoutData];

        const dragIndex = items.findIndex((f) => f.label === dragLabel);
        const dropIndex = items.findIndex((f) => f.label === dropLabel);

        if (dragIndex === -1 || dropIndex === -1) return;

        const dragItem = { ...items[dragIndex] };
        const dropItem = { ...items[dropIndex] };

        const tempId = dragItem.id;
        dragItem.id = dropItem.id;
        dropItem.id = tempId;

        items[dragIndex] = dropItem;
        items[dropIndex] = dragItem;

        updateState({ layoutData: items });
    };

    const fixDuplicateIds = (layout) => {
        const usedIds = new Set();
        return layout.map(item => {
            let newItem = { ...item };
            newItem.id = Number(newItem.id); // Ensure numeric

            if (!usedIds.has(newItem.id)) {
                usedIds.add(newItem.id);
            } else if (newItem.is_already_add || newItem.is_new) {
                // ID conflict, generate a unique one
                let newId = 1;
                while (usedIds.has(newId)) newId++;
                newItem.id = newId;
                usedIds.add(newId);
            } else {
                console.warn("Duplicate ID found in base layout:", newItem);
            }

            return newItem;
        });
    };

    const returnDefaultLayout = (fromReset = false) => {
        let Doctor_Notes_Layout = deepCopyObj(Doctor_Notes_Layout_Json);

        // const isAddLayout = (state.max_new_layout_alloted - state.new_layout_count) !== 0;

        if (fromReset) {
            let newDocLayout = [...Doctor_Notes_Layout, ...state.newLayoutData];
            // if (isAddLayout) {
            //     newDocLayout.push(deepCopyObj({
            //         ...defaultAddNew,
            //         id: getNextId(newDocLayout)
            //     }));
            // }

            // Fix duplicated IDs before returning
            return deepCopyObj(fixDuplicateIds(newDocLayout));
        }

        // if (isAddLayout) {
        //     Doctor_Notes_Layout.push(deepCopyObj({
        //         ...defaultAddNew,
        //         id: getNextId(Doctor_Notes_Layout)
        //     }));
        // }

        // Fix duplicated IDs before returning
        return deepCopyObj(fixDuplicateIds(Doctor_Notes_Layout));
    }

    // API INTEGRATION STARTS HERE

    const getLayoutConfiguration = () => {
        try {
            RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_LAYOUT)
                .then((response) => {
                    if (response.data.status === "success") {
                        const { field_data, max_new_layout_alloted, new_layout_count } = response.data.data;
                        const { layout_data } = field_data;
                        // const isAddLayout = (max_new_layout_alloted - new_layout_count) !== 0;
                        const modifiedLeftData = layout_data?.map(item =>
                            item.is_new ? { ...item, is_already_add: true } : { ...item }
                        );
                        updateState({
                            layoutData: layout_data
                                ? [...modifiedLeftData,
                                // ...(isAddLayout ? [deepCopyObj({ ...defaultAddNew, id: getNextId(modifiedLeftData) })] : [])
                                ]
                                : returnDefaultLayout(),
                            newLayoutData: layout_data
                                ? deepCopyObj(modifiedLeftData.filter(item => item.is_new))
                                : [],
                            max_new_layout_alloted,
                            new_layout_count,
                            org_new_layout_count: new_layout_count,
                        })
                    }
                }).catch((error) => {
                    errorMessage(error?.response?.data?.message || error.message)
                    updateState({
                        layoutData: returnDefaultLayout()
                    })
                })

        } catch (e) {
            errorMessage(e.message)
        }
    }

    const postLayoutConfiguration = () => {
        try {
            setState((prev) => ({...prev, is_save_layout: true }))
            const data = {
                "layout_data": state.layoutData?.reduce((acc, item) => {
                    // Skip items where both are empty
                    if (((!item.label && !item.custom_name && item.field_name === "" && item.is_newly_add === undefined) ||
                        (item.label && item.custom_name && item.field_name === "" && item.is_newly_add === undefined))) {
                        return acc;
                    }

                    const { is_newly_add, ...itemWithoutIsNewlyAdd } = item;

                    acc.push(item.is_new
                        ? { ...itemWithoutIsNewlyAdd, field_name: item.label?.toLowerCase()?.replace(/\s+/g, "_") }
                        : itemWithoutIsNewlyAdd
                    );

                    return acc;
                }, [])
            }
            const msg = validateDuplicate(data.layout_data);

            if (msg) {
                errorMessage(msg)
            } else {
                RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_LAYOUT)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMessage(response.data.message)
                            setState((prev) => ({...prev, is_save_layout: false }));
                            getLayoutConfiguration()
                        }
                    }).catch((error) => {
                        setState((prev) => ({...prev, is_save_layout: false }));
                        errorMessage(error?.response?.data?.message || error?.message)
                    })
            }

        } catch (e) {
            setState((prev) => ({...prev, is_save_layout: false }))
            errorMessage(e.message)
        }
    }
    // API INTEGRATION ENDS HERE

    return (
        <Box component={"div"} padding={"0.625vw"} sx={{ height: "80vh", backgroundColor: "#F5F8F7" }} >
            {/* Header */}
            <Box className="eMed_layout_item">
                <Typography fontSize={'0.9vw'} fontWeight={600} paddingLeft={"1vw"} color={"#616161"}>System Name</Typography>
                <Typography fontSize={'0.9vw'} fontWeight={600} paddingLeft={"1vw"} color={"#616161"}>Custom Name</Typography>
            </Box>
            {/* Content */}
            <Box sx={{ width: "100%", height: "65vh", overflow: "auto" }}>
                {state.layoutData?.map((item, index, arr) => {
                    // const isAddBtn = (arr?.length - 1 === index) && canAddNewlayout();
                    // const disableBtn = !(item?.label && item?.custom_name);
                    const isDraggable = (!item?.is_new && !!item?.label && !!item?.custom_name) ||
                        (item?.is_new && !!item?.label && !!item?.custom_name && (item?.is_already_add === true || item?.is_newly_add === true));
                    return (
                        <Box key={`${item.id}_${index}`}
                            className="eMed_layout_item"
                            draggable={isDraggable}
                            onDragOver={(isDraggable) ? (e) => e.preventDefault() : undefined}
                            onDragStart={(isDraggable) ? handleDrag : undefined}
                            onDrop={(isDraggable) ? handleDrop : undefined}
                            id={item.label}>
                            <Box component={'div'} height={'100%'} display={'flex'} pl={'1vw'} alignItems={'center'}>
                                <img className="eMed_demolayout_right2_field_img" src={ImagePaths.DragIndicator.default} alt="" style={{ visibility: isDraggable ? "visible" : "hidden" }} />
                                <FormControlLabel control={
                                    <Checkbox id={item.id} checked={item.is_active}
                                        onChange={(e) => {
                                            const updatedState = state.layoutData.map((obj) =>
                                                obj.id === item.id ? { ...obj, is_active: e.target.checked } : obj
                                            );
                                            updateState({ layoutData: [...updatedState] })
                                        }}
                                        size='small' />}
                                    label={ 
                                        ((item.label && !item.is_new) || (item?.label && item.is_new && item.is_already_add)) ? (
                                            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>
                                                {item.label}
                                            </Typography>
                                        ) : (
                                            <TextField
                                                autoComplete='off'
                                                size='small'
                                                sx={{ marginTop: "0.1vw", width: "20vw" }}
                                                inputProps={{ maxLength: 50 }}
                                                value={item.label ? item.label : ''}
                                                inputRef={(el) => {
                                                    if (el && item.is_new) {
                                                        labelRefs.current[item.id] = el;
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const updatedState = state.layoutData.map((obj) =>
                                                        obj.id === item.id ? { ...obj, label: e.target.value } : obj
                                                    );
                                                    updateState({ layoutData: [...updatedState] })
                                                }}
                                            />)
                                    } />
                            </Box>
                            <Box sx={{ display: "flex", alignItems: "center", paddingLeft: '1vw' }}>
                                <TextField
                                    size='small'
                                    sx={{ width: "20vw" }}
                                    inputProps={{ maxLength: 50 }}
                                    autoComplete='off'
                                    value={item?.custom_name || ''}
                                    onChange={(e) => {
                                        const updatedState = state.layoutData.map((obj) =>
                                            obj.id === item.id ? { ...obj, custom_name: e.target.value } : obj
                                        );
                                        updateState({ layoutData: [...updatedState] })
                                    }}
                                />
                                {/* Show Add Button Only on Last Row */}
                                {/* {isAddBtn && <IconButton size="small"
                                    disabled={disableBtn}
                                    variant='contained' sx={{ width: "fit-content" }}
                                    onClick={() => {
                                        const errorMsg = validateDuplicate(arr);
                                        if (errorMsg) {
                                            errorMessage(errorMsg)
                                        } else {
                                            handleAddItem()
                                        }
                                    }}>
                                    <img src={disableBtn ? ImagePaths.DisabledAddIcon.default : ImagePaths.AddIcon.default} alt="add" className='eMed_action_img' />
                                </IconButton>
                                } */}
                            </Box>

                        </Box>
                    )
                })}
            </Box>
            <Box sx={{ width: "100%", height: "5vh", background: "white", display: "flex", justifyContent: "center", alignItems: "center", gap: "1vw" }}>
                <Button variant='outlined' size="small" id="eMed_Config_btn"
                    onClick={() => {
                        updateState({
                            layoutData: returnDefaultLayout(true),
                            new_layout_count: state.org_new_layout_count,
                        })
                    }} >Reset Layout</Button>

                <Button variant='contained' size="small" id="eMed_Config_btn" disabled={state.is_save_layout}
                    onClick={() => {
                        // const lastItem = state.layoutData[state.layoutData.length - 1];
                        // if ((state.max_new_layout_alloted - state.new_layout_count) === 1 && (lastItem.label && lastItem.custom_name)) { handleAddItem(true) }
                        // else { postLayoutConfiguration() }
                        postLayoutConfiguration()
                    }}>Save Layout</Button>
            </Box>
            {(state.isErrorMsg || state.successMsg) && (
                <ToastMsg
                    severity={state.isErrorMsg ? 'error' : 'success'}
                    msg={state.isErrorMsg ? state.isErrorMsgText : state.successMsgText}
                    msgPop={msgClose.bind(this)}
                />
            )}
        </Box>
    )
}

export default DoctorLayoutConfig